/////////////////////////////////////////////////////////////////////
// Change hex color into RGB 
/////////////////////////////////////////////////////////////////////
export const getRGBColor = (hex: any, type: any) => {
  let color = hex.replace(/#/g, "")
  // rgb values
  var r = parseInt(color.substr(0, 2), 16)
  var g = parseInt(color.substr(2, 2), 16)
  var b = parseInt(color.substr(4, 2), 16)

  return `--color-${type}: ${r}, ${g}, ${b};`
}


/////////////////////////////////////////////////////////////////////
// Determine the accessible color of text
/////////////////////////////////////////////////////////////////////
export const getAccessibleColor = (hex: any) => {
  let color = hex.replace(/#/g, "")
  // rgb values
  var r = parseInt(color.substr(0, 2), 16)
  var g = parseInt(color.substr(2, 2), 16)
  var b = parseInt(color.substr(4, 2), 16)
  var yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? "#000000" : "#FFFFFF"
}

//Color Decider
export const colorMapping = {
  Cash: "bg-green-600",
  Online: "bg-blue-600",
  EWallet: "bg-teal-600",
  PaybyLink: "bg-purple-600",
  Subscription: "bg-orange-600",
  Pending: "bg-gray-600",
  PartiallyPaid: "bg-yellow-600",
  Prepaid: "bg-blue-600",
  Paid: "bg-green-600",
  Refunded: "bg-red-600",
  Processing: "bg-orange-600",
  Completed: "bg-green-600",
  Cancelled: "bg-red-600",
  BookingRequested: "bg-blue-600",
  BookingConfirmed: "bg-green-600",
  DriverAssigned: "bg-teal-600",
  NA: "bg-gray-500",
  BookingCanceled: "bg-red-600",
  Accepted: "bg-green-600",
  OnTheWay: "bg-yellow-600",
  ArrivedAtPickupLocation: "bg-blue-600",
  CargoLoaded: "bg-green-600",
  CargoDamaged: "bg-red-600",
  DeliveryFailed: "bg-red-600",
  VehicleBreakdown: "bg-red-600",
  CargoLoadingIssue: "bg-orange-600",
  InTransit: "bg-blue-600",
  StoppedForInspection: "bg-yellow-600",
  DelayedInTransit: "bg-orange-600",
  ArrivedAtDeliveryLocation: "bg-blue-600",
  CargoUnloaded: "bg-green-500",
  DeliveryCompleted: "bg-green-600",
  ShippingNotRequired: "bg-gray-600",
  Created: "bg-blue-600",
  Serviceable: "bg-green-600",
  NonServiceable: "bg-red-600",
  SearchingForAgent: "bg-orange-600",
  Packed: "bg-blue-600",
  AgentAssigned: "bg-teal-600",
  ReadyToShip: "bg-green-500",
  ShippingInProgress: "bg-blue-600",
  InProgress: "bg-blue-600",
  Shipped: "bg-orange-600",
  AtPickupLocation: "bg-teal-600",
  OrderPickedUp: "bg-green-500",
  AtDropLocation: "bg-teal-600",
  OutForDelivery: "bg-orange-600",
  OrderDelivered: "bg-green-500",
  Delivered: "bg-green-500",
  RTOInitiated: "bg-red-600",
  PartiallyReturned: "bg-orange-600",
  Liquidated: "bg-red-600",
  RTODisposed: "bg-red-600",
  RTODelivered: "bg-green-500",
  Parcel: "bg-orange-600",
  PartTruckLoad: "bg-teal-600",
  FullTruckLoad: "bg-green-500",
  Select: "bg-gray-300"
};
